export default {"src":"/_next/static/media/error.87f75375.svg","height":105,"width":92,"blurWidth":0,"blurHeight":0};